// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import siteMessage from "@insite/client-framework/SiteMessage";
import Icon from "@insite/mobius/Icon";
import Tooltip from "@werner/MobiusOverrides/Tooltip/Tooltip";
import Exclamation from "@werner/XDL/Icons/Exclamation";
import { isSiteMessageEmpty } from "@werner/XDL/Utilities";
import React from "react";

interface Props {
    message?: string;
    icon?: string | React.ComponentType<{}>;
    iconSize?: number;
    iconColor?: string;
}

const FieldInfoTooltip: React.FC<Props> = props => {
    const { icon, iconSize, message, iconColor } = props;
    if (!message || isSiteMessageEmpty(message)) {
        return null;
    }
    return (
        <Tooltip
            triggerComponent={<Icon src={icon || Exclamation} color={iconColor} size={iconSize || 16} />}
            text={siteMessage(message)}
        />
    );
};

export default FieldInfoTooltip;
